import {
    Breakpoints,
    Text,
    TextTag,
    TokenTextColor,
} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import {Offers, Safety, UsedCarPrivate} from '@volkswagen-onehub/icons-core'
import React from 'react'
import {anchors} from '../../../assets/css-vars/anchors'
import {AdditionalPromoText} from '../../../types/singleModelInterface'
import getAdditionalPromoText from '../../../utils/text/getAdditionalPromoText'
import STYlE_CONSTANTS from '../../../utils/style/styleConstants'

const PromotionalPackageWrapper = styled.fieldset`
    --legend-spacing: 8px;
    border: 2px solid ${(props) => props.theme.colors.border.legalframe};
    border-radius: ${(props) => props.theme.size.borderRadius.small};
    margin: 0;
    padding: 50px 15px;

    @media only screen and (min-width: ${Breakpoints.b560}px) {
        --legend-spacing: 16px;
        padding-top: 30px;
        padding-right: 60px;
        padding-left: 60px;
    }
`

const PromotionalPackageTitle = styled(Text)`
    font-size: 18px;
    line-height: 1;
    margin: 0 auto;
    padding-right: var(--legend-spacing);
    padding-left: var(--legend-spacing);
    text-align: center;

    @media only screen and (min-width: ${Breakpoints.b560}px) {
        font-size: 24px;
        padding-right: var(--legend-spacing);
        padding-left: var(--legend-spacing);
    }
`

const PromotionalPackageList = styled.ul`
    list-style: none;
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 0 0 var(--legend-spacing);
    margin: 0;
`

const PromotionalPackageListItem = styled.li`
    display: grid;
    grid-template-columns: 44px 1fr;
    gap: 20px;
    align-items: center;
    font-size: 16px;
    line-height: 1.5;

    @media only screen and (min-width: ${Breakpoints.b560}px) {
        gap: 30px;
        font-size: 18px;
        line-height: 1.4;
    }

    svg {
        width: 100%;
        height: auto;
    }

    span {
        ${anchors}

        ul {
            list-style: none;
            padding-left: 0;

            li {
                &::before {
                    content: '\\2014';
                    color: ${(props) => props.theme.colors.content.secondary};
                    font-weight: ${STYlE_CONSTANTS.TEXT_WEIGHT_BOLD};
                    margin-right: 5px;
                }
            }
        }
    }
`

const PromotionalPackageIconContainer = styled.div`
    svg {
        fill: ${(props) => props.theme.colors.content.active};
    }
`

export interface PromotionalPackageProps {
    promotionText: AdditionalPromoText
}

export default function PromotionalPackage(
    props: PromotionalPackageProps
): React.JSX.Element {
    const promotionalPackageCopy = getAdditionalPromoText(props.promotionText)

    return (
        <PromotionalPackageWrapper>
            <PromotionalPackageTitle
                tag={TextTag.legend}
                bold
                color={TokenTextColor.primary}
            >
                {promotionalPackageCopy.title}
            </PromotionalPackageTitle>

            <PromotionalPackageList>
                {props.promotionText
                    .is_additional_promotion_detail_visible_1 ? (
                    <PromotionalPackageListItem>
                        <PromotionalPackageIconContainer>
                            <Offers aria-hidden={true} />
                        </PromotionalPackageIconContainer>

                        <span
                            dangerouslySetInnerHTML={{
                                __html: promotionalPackageCopy.firstDetail,
                            }}
                        />
                    </PromotionalPackageListItem>
                ) : undefined}

                {props.promotionText
                    .is_additional_promotion_detail_visible_2 ? (
                    <PromotionalPackageListItem>
                        <PromotionalPackageIconContainer>
                            <Safety aria-hidden={true} />
                        </PromotionalPackageIconContainer>

                        <span
                            dangerouslySetInnerHTML={{
                                __html: promotionalPackageCopy.secondDetail,
                            }}
                        />
                    </PromotionalPackageListItem>
                ) : undefined}

                {props.promotionText
                    .is_additional_promotion_detail_visible_3 ? (
                    <PromotionalPackageListItem>
                        <PromotionalPackageIconContainer>
                            <UsedCarPrivate aria-hidden={true} />
                        </PromotionalPackageIconContainer>

                        <span
                            dangerouslySetInnerHTML={{
                                __html: promotionalPackageCopy.thirdDetail,
                            }}
                        />
                    </PromotionalPackageListItem>
                ) : undefined}
            </PromotionalPackageList>
        </PromotionalPackageWrapper>
    )
}
